import { httpRequest } from "../../../utils/HttpRequest";
import { EnquiryStatisticsItem, EnquiryStatisticsQuery } from "./enquiryType";

class EnquiryService {

    async enquiryStatic(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/statisticsPage";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async enquiryStaticExport(params: any) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/statistics/export";
        return await httpRequest.postFile(apiUrl, params);
    }

    async statisticsDetail(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseEnquiry/statisticsDetail";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }
}
export const enquiryService = new EnquiryService();
